document.addEventListener("DOMContentLoaded", () => {
    if (window.matchMedia("(max-width: 768px)").matches) return;

    const cards = document.querySelectorAll(".nav-card");

    const preloadAndDecode = async (src) => {
        if (!src) return;
        const img = new Image();
        img.src = src;
        if (img.decode) {
            try {
                await img.decode();
            } catch (e) {
            }
        }
    };

    cards.forEach(async (card) => {
        const hoverSrc = card.dataset.hover;
        const mainSrc = card.dataset.main;

        const itemLayer = card.querySelector(".nav-card__img.is-item");
        const items = card.querySelectorAll(".nav-card__list-item");

        preloadAndDecode(mainSrc);
        preloadAndDecode(hoverSrc);

        items.forEach(item => preloadAndDecode(item.dataset.itemImage));

        items.forEach((item) => {
            const itemImg = item.dataset.itemImage;

            item.addEventListener("mouseenter", () => {
                if (!itemImg || !itemLayer) return;
                itemLayer.src = itemImg;
                card.classList.add("has-item-hover");
            });

            //   item.addEventListener("mouseleave", () => {
            //     card.classList.remove("has-item-hover");
            //   });
        });

        card.addEventListener("mouseleave", () => {
            card.classList.remove("has-item-hover");
        });
    });
});